import React from 'react';
import './ComplianceSection.css';

const ComplianceSection: React.FC = () => {
  return (
    <section id="compliance" className="compliance-section">
      <div className="compliance-container">
        <div className="compliance-header">
          <h2 className="compliance-title">Fully India-compliant.</h2>
          <p className="compliance-description">
            Stay compliant with TRAI & DoT regulations without the complexity. Our platform handles 
            all compliance requirements, so you can focus on your business.
          </p>
        </div>
        
        <div className="compliance-content">
          <div className="compliance-cards">
            <div className="compliance-card primary">
              <div className="card-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="currentColor"/>
                </svg>
              </div>
              <h3 className="card-title">Stay inside TRAI & DoT lines</h3>
              <p className="card-description">
                Our platform automatically ensures compliance with all Indian telecom regulations, 
                so you never have to worry about regulatory issues.
              </p>
            </div>
            
            <div className="compliance-card secondary">
              <div className="card-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                  <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" fill="currentColor"/>
                </svg>
              </div>
              <h3 className="card-title">24x7x365 Support</h3>
              <p className="card-description">
                Dedicated support team available round the clock to help you with any compliance 
                questions or technical issues.
              </p>
            </div>
            
            <div className="compliance-card tertiary">
              <div className="card-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                  <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" fill="currentColor"/>
                </svg>
              </div>
              <h3 className="card-title">24x7 CDR Retention</h3>
              <p className="card-description">
                Automatic Call Detail Record retention as per regulatory requirements with 
                secure storage and easy retrieval.
              </p>
            </div>
          </div>
          
          <div className="compliance-table">
            <div className="table-header">
              <div className="table-cell">Compliance Feature</div>
              <div className="table-cell">Status</div>
            </div>
            <div className="table-row">
              <div className="table-cell">TRAI Compliance</div>
              <div className="table-cell">
                <span className="status-check">✓</span>
              </div>
            </div>
            <div className="table-row">
              <div className="table-cell">DoT Regulations</div>
              <div className="table-cell">
                <span className="status-check">✓</span>
              </div>
            </div>
            <div className="table-row">
              <div className="table-cell">CDR Retention</div>
              <div className="table-cell">
                <span className="status-check">✓</span>
              </div>
            </div>
            <div className="table-row">
              <div className="table-cell">Data Privacy</div>
              <div className="table-cell">
                <span className="status-check">✓</span>
              </div>
            </div>
            <div className="table-row">
              <div className="table-cell">Audit Trail</div>
              <div className="table-cell">
                <span className="status-check">✓</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComplianceSection;
